<template>
  <div v-if="logs.length > 0" class="w-full shrink-0 mt-16 md:-mt-4">
    <q-virtual-scroll
      v-slot="{ item }"
      style="max-height: 100%"
      :items="logs"
      class="w-full virtual-scroll"
    >
      <div
        class="flex items-start gap-4 flex-nowrap py-12 border-b border-neutral-20 md:gap-6"
      >
        <OAvatar :size="Screen.lt.md ? '1.625rem' : '2rem'"></OAvatar>

        <div class="flex flex-col">
          <div class="flex gap-4 md:flex-col md:gap-0 md:!text-12">
            <p class="text-headline-3 text-neutral-70 capitalize">
              {{ item.dados_usuario.nome }}
            </p>
            <span class="text-pararaphy-3 text-neutral-40">•</span>
            <p class="text-pararaphy-3 text-neutral-70 md:!text-paragraph-4">
              {{ FDataAndTime(item.data) }}
            </p>
          </div>

          <div class="text-pararaphy-2 text-neutral-100">
            {{ item.frase }}
            <!-- {{
              `${item.campo_front}: ${t('from')} ${
                item.valor_anterior || '-'
              } ${t('to')} ${item.valor_posterior || '-'}`
            }} -->
          </div>
        </div>
      </div>
    </q-virtual-scroll>
  </div>

  <BaseLoader v-else-if="loading" class="h-full w-full grid place-items-center mt-48" />

  <div v-else class="grid w-full place-items-center -mt-56">
    <div>
      <q-icon
        class="block opacity-30 mx-auto"
        name="fluorescent"
        size="2.5rem"
      ></q-icon>
      <p class="text-paragraph-2 text-center opacity-40">
        {{ t('noChanges') }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Screen } from 'quasar'
import { useI18n } from 'vue-i18n'
import BaseLoader from 'components/Loader/BaseLoader.vue'
import GLOBAL from 'js/utils/GLOBAL'
import OAvatar from 'components/Avatar/OAvatar.vue'

const { t } = useI18n()
const { FDataAndTime, removeHTMLFromString } = GLOBAL

const logLoading = ref(false)

const { logs } = defineProps({
  logs: {
    type: Array,
    default: () => [],
  },
  loading:Boolean
})
</script>

<style lang="scss" scoped></style>
